import { render, staticRenderFns } from "./NoticeHeader.vue?vue&type=template&id=31ed3c50&"
import script from "./NoticeHeader.vue?vue&type=script&lang=js&"
export * from "./NoticeHeader.vue?vue&type=script&lang=js&"
import style0 from "./NoticeHeader.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAppBar } from 'vuetify/lib/components/VAppBar';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VAppBar,VImg})
